/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Mon Mar 11 2024
 **/

import { atom } from "jotai";

import { SidebarID } from "@/frameworks/core/commons";

export const MyRoomIDAtom = atom<string | null>("");

export const SpaceIDAtom = atom<string | null>("");

export const MyRoomSettingInformationAtom = atom<Nullable<WebServices.MyRoom.Update.Request>>(null);

type SettingInformationType = {
	spaceThemeId: string;
	name: string;
	description?: string;
	accessAllowType: SwaggerModels.SpaceAccessAllowType;
	allowSearch: boolean;
	allowOtherGroupUser: boolean;
	keywords: string[];
	groupID: string;
	spaceID: string;
	thumbnailPath: string;
	useAudioZone: boolean;
};

export const SpaceSettingInformationAtom = atom<Nullable<SettingInformationType>>(null);

export const InviteSpaceMemberAtom = atom<Nullable<WebServices.Space.Detail.Data>>(null);

export const CreateSpaceGroupIDAtom = atom<string | null>("");

export const OpenSpaceInviteGroupIDAtom = atom<string | null>("");

export const GroupSettingGroupIDAtom = atom<string | null>(null);

export const GroupAtom = atom<Nullable<WebServices.Group.Inquiry.Data>>(null);

export const GroupRightSidebarIDAtom = atom<SidebarID | null>(null);

export const ManageSpaceMemberSpaceDetailAtom = atom<Nullable<WebServices.Space.Detail.Data>>(null);

export const AddUserPanelAtom = atom<Nullable<{ name: string; groupID: string }>>(null);

export const GroupSettingActiveTabAtom = atom<"setting-member" | "setting-request">("setting-member");

export const SpaceManageMemberTabAtom = atom<"request-status" | "current-members">("request-status");

export const ViewGroupSpacesAtom = atom<Nullable<{ name: string; groupID: string }>>(null);
